import { render, staticRenderFns } from "./HomeTaskCoordination.vue?vue&type=template&id=16b0607a&scoped=true&"
import script from "./HomeTaskCoordination.vue?vue&type=script&lang=js&"
export * from "./HomeTaskCoordination.vue?vue&type=script&lang=js&"
import style0 from "./HomeTaskCoordination.vue?vue&type=style&index=0&id=16b0607a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0607a",
  null
  
)

export default component.exports